<template>
  <div>
    <div >
      <div
          class="text-center preview-quiz edit-quiz p-3 mr-1 cursor-pointer  text-sm text-primary border border-solid border-primary"
          @click="backToEditQuiz"
        >
          <span class="ml-2 text-base text-primary">Edit Quiz</span>
        </div> 
    </div>
    <div v-if="quiz_finish == false">
      <div v-if="next_question.length > 1" class="old-question">
        <h3 class="old-question-h">
          {{ next_question[next_question.length - 2].question }}
        </h3>
        <div>
          <vs-button
            icon-pack="feather"
            icon="icon-edit"
            @click="backSelect()"
            type="border"
            class="old_option option"
            v-if="
              next_question[next_question.length - 2].qtype != 'multiple-select'
            "
          >
            {{ next_question[next_question.length - 2].select_option }}
          </vs-button>
          <vs-row v-else>
            <vs-col
              :key="index"
              v-for="(option, index) in next_question[next_question.length - 2]
                .select_option"
              vs-w="4"
              ><vs-button
                @click="backSelect()"
                color="primary"
                type="border"
                class="old_option option"
                icon-pack="feather"
                icon="icon-edit"
              >
                {{ option }}
              </vs-button>
            </vs-col>
          </vs-row>
        </div>
      </div>

      <!-- Next question -->
      <transition name="slide-fade">
        <div v-if="next_question.length > 0">
          <h3>{{ next_question[next_question.length - 1].question }}</h3>
          <div
            v-if="
              next_question[next_question.length - 1].qtype != 'multiple-select'
            "
          >
            <div
              :key="index"
              v-for="(option, index) in next_question[next_question.length - 1]
                .options"
            >
              <vs-button
                @click="
                  optionSelect(next_question[next_question.length - 1], option)
                "
                color="primary"
                type="border"
                class="option"
              >
                {{ option.text }}
              </vs-button>
            </div>
          </div>
          <vs-row v-else>
            <vs-col
              :key="index"
              v-for="(option, index) in next_question[next_question.length - 1]
                .options"
              vs-w="4"
              ><vs-button
                @click="multipleOptionSelect(option)"
                color="primary"
                :type="
                  multiple_select.includes(option.text) ? 'filled' : 'border'
                "
                icon-pack="feather"
                :icon="
                  multiple_select.includes(option.text) ? 'icon-check' : ''
                "
                class="option"
              >
                {{ option.text }}
              </vs-button>
            </vs-col>
          </vs-row>
          <vs-button
            @click="
              saveMultipleSelection(next_question[next_question.length - 1])
            "
            color="primary"
            type="filled"
            class="option float-right"
            v-if="multiple_select.length > 0"
          >
            Save ({{ multiple_select.length }})
          </vs-button>
        </div>
      </transition>
    </div>
    <div v-if="quiz_finish" class="text-center">
      <h1>Quiz is finished!</h1>
      <vs-button
        @click="restart()"
        color="primary"
        type="border"
        class="option"
      >
        Restart
      </vs-button>
    </div>
  </div>
</template>

<script>
import DataProvider from "../../services/data-provider";

export default {
  data() {
    return {
      all_questionnaire: [],
      next_question: [],
      old_answer: "",
      old_question: [],
      multiple_select: [],
      quiz_finish: false,
    };
  },
  created() {
    this.getQuestionnaire();
  },
  methods: {
    getQuestionnaire() {
      DataProvider.getDataFromFirestore("health_tracker").then(
        (res) => {
          console.log(res);
          if (res) {
            this.all_questionnaire = res.questions;
            this.next_question = [this.all_questionnaire[0]];
            console.log(this.next_question);
          }
        },
        (e) => {
          console.log("Error:", e);
          DataProvider.sendSentryErrorLog(err)
        }
      );
    },
    optionSelect(question, option) {
      console.log('optionSelect',question)
      if (
        option.next_question_if_answered == "" ||
        option.next_question_if_answered == null
      ) {
        this.quiz_finish = true;
        // this.saveQuizData();
      }
      this.next_question[this.next_question.length - 1].select_option =
        option.text;
      if (option.next_question_if_answered) {
        this.all_questionnaire.filter((res) => {
          if (res.id == option.next_question_if_answered) {
            this.next_question.push(res);
          }
        });
      }
      console.log(this.next_question);
    },
    saveMultipleSelection(question) {
      if (
        question.next_question_if_answered == "" ||
        question.next_question_if_answered == null
      ) {
        this.quiz_finish = true;
        // this.saveQuizData();
      }
      this.next_question[
        this.next_question.length - 1
      ].select_option = this.multiple_select;
      if (question.next_question_if_answered) {
        this.all_questionnaire.filter((res) => {
          if (res.id == question.next_question_if_answered) {
            this.next_question.push(res);
          }
        });
      }
      this.multiple_select = [];
      console.log(this.next_question);
    },
    multipleOptionSelect(option) {
      console.log('multipleOptionSelect',option)
      let i = this.multiple_select.indexOf(option.text);
      if (i != -1) {
        this.multiple_select.splice(i, 1);
      } else {
        this.multiple_select.push(option.text);
      }
    },
    saveQuizData() {
      DataProvider.postDataToFirestore({health_tracker_quiz_history:this.next_question}).then(
        (res) => {
          console.log("res:", res);
        },
        (e) => {
          console.log("Error", e);
        }
      );
    },
    backSelect() {
      this.next_question.pop();
      this.multiple_select = [];
    },
    restart() {
      this.getQuestionnaire();
      this.quiz_finish = false;
      this.next_question = [];
      this.multiple_select = [];
    },
    backToEditQuiz(){
      this.$router.back()
    }
  },
};
</script>

<style lang="scss">
.option {
  //   border: 1px solid;
  margin: 10px;
  padding: 8px;
  border-radius: 50px;
}
.old-question {
  margin-bottom: 50px;
}
h3.old-question-h {
  color: #828282;
}
.edit-quiz {
    width: 125px;
    margin: auto;
    border-radius: 50px;
}
.old_option {
  border-color: #a0a0a0 !important;
  color: #676767 !important;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>